import { IsDeviceLogged, Login } from '../api'
import { sleep } from "aldoo-ra/Time"

import BreakAuth from './break-await-auth'

const { GetBreakAwaitAuth, SetBreakAwaitAuth } = BreakAuth


//check for a logged device every X seconds
const awaitAuth = async (auth) => {
    //reset login break, external systems may break it
    SetBreakAwaitAuth(false)

    while (true) {
        //check if we need to break the loop
        if (GetBreakAwaitAuth()) break
        //wait for 1 second
        await sleep(1000)
        //check if the device is logged
        const deviceLoginState = await IsDeviceLogged(auth)
        //Return true on successful device login
        if (deviceLoginState?.login) {
            //the device is logged in but this login_state answer carries no
            //token (APIs answering the old Books contract): fetch it with a login
            if (!deviceLoginState.auth_token) {
                const login = await Login(auth)
                if (login?.auth_token) return { ...deviceLoginState, auth_token: login.auth_token, user: login.user }
            }
            return deviceLoginState
        }
    }
    //loop was broken (modal closed / external break) without a login:
    //always return an object so callers can safely read .login
    return { login: false }
}

export default awaitAuth